export default __webpack_public_path__ + "static/media/undraw_teaching_f1cm.39a5b2ea.svg";